export const defaultData = {
  id: 101,
  designId: 1,
  width: 250,
  height: 400,
  bgColor: "red",
  bgImageUri: "https://r.resimlink.com/u-A1rvJDjhe.png",
  items: [
    {
      id: 1001,
      pageId: 101,
      type: "text",
      value: "Hi !",
      tag: "@hiMessage",
      rotationAngle: -45,
      translateX: 49.660425586960585,
      translateY: -319.33957441303943,
      fontSize: 24,
      fontColor: "#079207",
      fontFamily: "",
      width: "159",
      horizontalAlignment: "",
      verticalAlignment: "",
      textAlign: "right",
    },
    {
      id: 1002,
      pageId: 101,
      type: "text",
      value: "Welcome",
      tag: "@welcome",
      rotationAngle: -45,
      translateX: 13.083261120685236,
      translateY: -356.9167388793148,
      fontSize: 24,
      fontColor: "#fa2311",
      fontFamily: "",
      width: "100",
      horizontalAlignment: "",
      verticalAlignment: "",
      textAlign: "right",
    },
    {
      id: 1003,
      pageId: 101,
      type: "text",
      value: "Name",
      tag: "@people",
      rotationAngle: 0,
      translateX: 83,
      translateY: -190,
      fontSize: 24,
      fontColor: "#595e9b",
      fontFamily: "",
      width: 100,
      horizontalAlignment: "",
      verticalAlignment: "",
      textAlign: "right",
    },
  ],
};
